import type { DeepRequired } from '../fixtures.types'

const group: DeepRequired<Group> = {
  __typename: 'Group',
  accept_reminders: null,
  disabled: null,
  group_id: 'TEST_ID',
  group_name: null,
  organisation_id: null,
  user_ids: [],
  users: [],
}

export default group
